import { useContext, useEffect, useState } from 'react';
import { ConfirmContext } from './ConfirmContextProvider';

const useConfirm = () => {
  const [confirm, setConfirm] = useContext(ConfirmContext);
  const [needsCleanup, setNeedsCleanup] = useState(false);

  const confirmation = (title, description) => {
    const promise = new Promise((resolve, reject) => {
      setConfirm({
        title, description, isOpen: true, proceed: resolve, cancel: reject, infoPopup: false,
      });
      setNeedsCleanup(true);
    });

    const reset = () => {
      setConfirm({
        title: '', description: '', proceed: null, cancel: null, isOpen: false, infoPopup: false,
      });
      setNeedsCleanup(false);
    };

    return promise.then(
      () => {
        reset();
        return true;
      },
      () => {
        reset();
        return false;
      },
    );
  };

  const info = (title, description, type = 'success') => {
    const promise = new Promise((resolve, reject) => {
      setConfirm({
        title, description, isOpen: true, proceed: resolve, cancel: reject, infoPopup: true, infoType: type,
      });
      setNeedsCleanup(true);
    });

    const reset = () => {
      setConfirm({
        title: '', description: '', proceed: null, cancel: null, isOpen: false, infoPopup: true, infoType: type,
      });
      setNeedsCleanup(false);
    };

    return promise.then(
      () => {
        reset();
        return true;
      },
      () => {
        reset();
        return true;
      },
    );
  };

  // Call cancel in a cleanup func to avoid dangling confirm dialog
  useEffect(() => () => {
    if (confirm.cancel && needsCleanup) {
      confirm.cancel();
    }
  }, [confirm, needsCleanup]);

  return {
    ...confirm,
    confirmation,
    info,
  };
};

export default useConfirm;
